<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        representanteid: '',
        representantenome: '',
        representanteemail: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.representantenome === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Codigo"
                label-for="representanteid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representanteid"
                    id="representanteid"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite o id"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Nome"
                label-for="representantenome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representantenome"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representantenome"
                    id="representantenome"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Nome abreviado"
                label-for="representantenomeabreviado"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representantenomeabreviado"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representantenomeabreviado"
                    id="representantenomeabreviado"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Email"
                label-for="representanteemail"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representanteemail"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representanteemail"
                    id="representanteemail"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Sequencial de pedidos"
                label-for="representanteseqpedido"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representanteseqpedido"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representanteseqpedido"
                    id="representanteseqpedido"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Ativo"
                label-for="representanteativo"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representanteativo"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.representanteativo"
                    id="representanteativo"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Comissão"
                label-for="representantepercentualcomissao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representantepercentualcomissao"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representantepercentualcomissao"
                    id="representantepercentualcomissao"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Endereco"
                label-for="representanteendereco"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representanteendereco"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representanteendereco"
                    id="representanteendereco"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Bairro"
                label-for="representantebairro"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representantebairro"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representantebairro"
                    id="representantebairro"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cidade"
                label-for="representantecidade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="representantecidade"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.representantecidade"
                    id="representantecidade"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Uf"
                label-for="uf_nome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="uf_nome"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.uf.uf_nome"
                    id="uf_nome"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Pais"
                label-for="pais_nome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="pais_nome"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.pais.pais_nome"
                    id="pais_nome"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
